import modal from '@/utils/modal.js';
import eventbus from '@/utils/eventbus';
import { defineAsyncComponent } from 'vue';

const CustomerCard = defineAsyncComponent(async () => {
  return await import(/* webpackChunkName: "stage-2" */'@/components/CustomerCard');
});

function openPopupProfileCard (merchantCustomerId, defaultTab) {
  const m = modal.create(CustomerCard, true, {
    props: {
      defaultTab,
      merchantCustomerId,
    },
  });
  m.body.setAttribute('data-gmf', ''); // This signals that we are already handling this element (so for example elAttach wont mess with it)
  m.body.classList.add('gmf-customer-card-modal');
}

eventbus.on('openPopupProfileCard', openPopupProfileCard);
